import React from "react";
import { ApiResponseLog } from "generated/graphql";
import {
  TableRow,
  TableCell,
  Typography,
  Dialog,
  IconButton,
  Button,
} from "@material-ui/core";
import pretty from "Shared/pretty";
import { Info } from "@material-ui/icons";
import useStyles from "./styles";

const ApiResponseTableRow = ({ response, request, createdAt }: ApiResponseLog) => {
  const status = response ? "OK" : "FAILED";
  const [isModalOpen, setIsModalOpen] = React.useState({
    request: false,
    response: false,
  });
  const toggleRequestModal = () => {
    setIsModalOpen({
      request: !isModalOpen.request,
      response: isModalOpen.response,
    });
  };

  const toggleResponseModal = () => {
    setIsModalOpen({
      request: isModalOpen.request,
      response: !isModalOpen.response,
    });
  };
  const classes = useStyles();

  return (
    <TableRow>
      <TableCell>
        {pretty.date(createdAt, { withTime: true })}
      </TableCell>
      <TableCell>{status}</TableCell>
      <TableCell>
        {response && response.length > 20 ? (
          <>
            {response.slice(0, 20)}...
            <IconButton
              className={classes.iconButton}
              disableRipple={true}
              size="small"
              onClick={toggleResponseModal}
            >
              <Info />
            </IconButton>
            <Dialog open={isModalOpen.response} onClose={toggleResponseModal}>
              <Typography className={classes.modalText}>{response}</Typography>
            </Dialog>
          </>
        ) : (
          <>{response}</>
        )}
      </TableCell>
      <TableCell>
        <Button
          disableRipple={true}
          color="primary"
          onClick={toggleRequestModal}
          className={classes.link}
        >
          View
        </Button>
        <Dialog open={isModalOpen.request} onClose={toggleRequestModal}>
          <Typography className={classes.modalText}>{request}</Typography>
        </Dialog>
      </TableCell>
    </TableRow>
  );
};
export default ApiResponseTableRow;
